/**
 * Phase 120 (Plan 120-02, D-120-08) — release-flag route / subtree guard.
 *
 * FAIL-CLOSED, the inverse of `RequireModule` (which trusts a fail-open
 * `hasModule()`): the flagged subtree renders only once the server has said
 * the flag is on. While the flag query is loading nothing is rendered (never
 * the subtree early, never a 404 flash); when the flag is off, the query
 * errored, the visitor is unauthenticated, or no `FlagsProvider` is mounted,
 * it renders `NotFoundPage` in place — a real 404 never changes the URL (same
 * contract as `RequireModule`).
 *
 * Presentation-only: this hides UI, it does not protect data. The enforcement
 * boundary is the backend `requireFlag` preHandler on the flagged routes.
 */
import type { ReactNode } from 'react';
import { useReleaseFlagsContext } from '../../services/flagsContext';
import { NotFoundPage } from '../../pages/NotFoundPage';

export function RequireFlag({ flag, children }: { flag: string; children: ReactNode }) {
  const { isOn, isLoading } = useReleaseFlagsContext();
  if (isLoading) return null;
  if (!isOn(flag)) return <NotFoundPage />;
  return <>{children}</>;
}
